// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__0nLJ-","section-1":"styles_section-1__3nzZe","content":"styles_content__Za-sC","section-2":"styles_section-2__4ugRM"};